export default __webpack_public_path__ + "static/revolution-8e4c1f6e8ca7332be74bd5250f0003a5.webp";